module.exports = __webpack_public_path__ + "img/register_1.48d8da36.png";